
import { Vue, Options } from "vue-class-component";
import OverallSummarySection from "@/app/ui/views/dashboard/cod-dashboard/component/overall-summary-section.vue";
import ListCourierPartnerSection from "@/app/ui/views/dashboard/cod-dashboard/component/list-courier-partner-section.vue";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import { DownloadSummaryCodRequest } from "@/data/payload/api/DashboardRequests";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getHubData } from "@/app/infrastructures/misc/Cookies";

@Options({
  components: { ListCourierPartnerSection, OverallSummarySection }
})
export default class CodDashboard extends Vue {
  created() {
    DashboardController.setFilterDateCodDashboard(new Date());
  }
  get filterDate() {
    return DashboardController.filterDateCodDashboard;
  }
  set filterDate(newValue: Date) {
    DashboardController.setFilterDateCodDashboard(newValue);
  }
  reRenderComponent = true;
  onSelectDatePicker() {
    this.reRenderComponent = false;
    this.$nextTick(() => {
      this.reRenderComponent = true;
    });
  }

  downloadSummary() {
    const filter = new DownloadSummaryCodRequest({
      filterDate: this.$moment(this.filterDate).format("YYYY-MM-DD"),
      cityCode: this.accountType === "pos" ? "" : this.cityCodes,
      hubId: getHubData()?.hubId || 0
    });

    DashboardController.getSummaryDownload({
      type: this.accountType === "pos" ? "pos" : "consol",
      filter: filter,
      version: "v1"
    });
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get accountType() {
    return this.dataProfile.account_type_detail.type;
  }

  get cityCodes() {
    const cities = this.dataProfile.account_location_list?.map(
      item => item.city_code
    );
    return cities?.join(",");
  }
  // snackbar
  snackbar = false;
  snackbarMessage =
    "Jumlah Sudah Setor akan selalu Rp0 hingga fitur Setor Harian Kurir rilis.";
  toggleSnackbar(bool: boolean) {
    this.snackbar = bool;
  }
}
